export default function getSpecialCharactersFilteredSearchText(searchText) {
    if (searchText) {
        const filteredSearchText = searchText.replace(/[\\[\]{}|^"'`]/g, '');
        if (filteredSearchText.length > 0) {
            return filteredSearchText;
        }
    }

    return '';
}
